import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Endpoints } from './Constants';
import RequestHelper from './RequestHelper';
export default {
  /**
   * Watch and Earn Start
   */
  startVideo: function () {
    var _startVideo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var watchAndEarnStartResponse;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return RequestHelper.apiGet({
                endpoint: Endpoints.WATCH_AND_EARN_START
              }, true);

            case 3:
              watchAndEarnStartResponse = _context.sent;

              if (!(watchAndEarnStartResponse.success === false)) {
                _context.next = 6;
                break;
              }

              throw Error(watchAndEarnStartResponse.error);

            case 6:
              return _context.abrupt("return", watchAndEarnStartResponse);

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              throw _context.t0;

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));

    function startVideo() {
      return _startVideo.apply(this, arguments);
    }

    return startVideo;
  }(),
  completeVideo: function () {
    var _completeVideo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var watchAndEarnCompleteResponse;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return RequestHelper.apiGet({
                endpoint: Endpoints.WATCH_AND_EARN_COMPLETE
              }, true);

            case 3:
              watchAndEarnCompleteResponse = _context2.sent;

              if (!(watchAndEarnCompleteResponse.success === false)) {
                _context2.next = 6;
                break;
              }

              throw Error(watchAndEarnCompleteResponse.error);

            case 6:
              return _context2.abrupt("return", watchAndEarnCompleteResponse);

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);
              throw _context2.t0;

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 9]]);
    }));

    function completeVideo() {
      return _completeVideo.apply(this, arguments);
    }

    return completeVideo;
  }()
};